import { Alert, Button, Code, CopyButton, Group, Stack, Text } from "@mantine/core";

import type { TokenCreated } from "../../api/generated/model";

export interface NewTokenSecretProps {
  created: TokenCreated;
  /** Forgets the secret: the caller resets the mutation that holds it. */
  onDone: () => void;
}

/** The one time the secret is shown (A1). It lives only in the create mutation's result. */
export function NewTokenSecret({ created, onDone }: NewTokenSecretProps) {
  return (
    <Alert color="teal" variant="light" title={`Copy the token "${created.name}" now`}>
      <Stack gap="sm">
        <Text size="sm">
          This is the only time Created.ai shows it. Keep it somewhere safe, such as a password
          manager: anyone who has it can act as you in this team until it expires.
        </Text>
        <Code block aria-label="New token">
          {created.token}
        </Code>
        <Group>
          <CopyButton value={created.token}>
            {({ copied, copy }) => (
              <Button variant="light" onClick={copy}>
                {copied ? "Copied" : "Copy token"}
              </Button>
            )}
          </CopyButton>
          <Button variant="subtle" onClick={onDone}>
            Done, hide it
          </Button>
        </Group>
      </Stack>
    </Alert>
  );
}
